import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllVideos } from "../../features/allVideos";
import { setPageNo } from "../../features/filter/filterSlice";

const digitToArray = (digit) => {
  let arr = [];

  for (let i = 0; i < digit; i++) {
    arr = [...arr, 1];
  }

  return arr;
};

export default function Pagination() {
  const dispatch = useDispatch();

  const { videos } = useSelector((state) => state.videos);
  const { allVideos } = useSelector((state) => state.allVideo);
  const { pageNo, search } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchAllVideos());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (e) => {
    dispatch(setPageNo(+e.target.innerText));
    // getPost(e.selected + 1);
  };

  const pageTabArr = search
    ? digitToArray(Math.ceil(videos?.length / 3))
    : digitToArray(Math.ceil(allVideos?.length / 3));

  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {pageNo > 0 &&
          allVideos?.length > 0 &&
          pageTabArr.map((itm, index) => {
            return (
              <div
                key={index}
                className={`${
                  index + 1 === pageNo ? `bg-blue-600 ` : `bg-blue-100 `
                } text-white px-4 py-1 rounded-full`}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePageClick(e);
                }}
              >
                {index + 1}
              </div>
            );
          })}
      </div>
    </section>
  );
}
